import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import Typography from '@material-ui/core/Typography';

import { AsyncChipsInput, FormActionButtons } from 'components';

import { deleteRelatedAccommodations } from 'actions/activityAndAccommodation';

import { ACCOMMODATIONS_TITLES } from 'graphql/queries/accommodations';

import { useStyles } from 'components/related-accommodations/styles';

const initialValues = {
  relatedAccommodations: []
};

const RelatedAccommodations = ({
  handleSubmit,
  setSubmitButton,
  isUpdate,
  ...otherProps
}) => {
  const { deleteRelatedAccommodations } = otherProps;
  const classes = useStyles();
  const [t] = useTranslation();

  const onDeleteHandler = item => {
    if (item.isCreated) deleteRelatedAccommodations(item.id);
  };

  return (
    <div className={classes.wrapper}>
      <Typography variant="h1" className={classes.title}>
        {t('Related Accommodations')}
      </Typography>
      <form onSubmit={handleSubmit}>
        <Field
          name={`relatedAccommodations`}
          className={classes.inputIndent}
          placeholder="Accommodations"
          maxLength="255"
          query={ACCOMMODATIONS_TITLES}
          queryName="accommodations"
          optionLabel="title"
          remove={onDeleteHandler}
          component={AsyncChipsInput}
        />

        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  deleteRelatedAccommodations: id => dispatch(deleteRelatedAccommodations(id))
});

export default reduxForm({
  form: 'relatedAccommodationsForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  touchOnBlur: false,
  initialValues
})(connect(null, mapDispatchToProps)(RelatedAccommodations));
